import Request from 'gd-request';

export default class ApiSetup {

    constructor() {}

    getSetupParameters() {
        return new Request(this, 'GET', 'setup-account');
    }

    createCompany(params) {
        return new Request(this, 'POST', 'setup-company', params);
    }
}